/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';

export const CHECKBOX = 'CHECKBOX';
export const SELECT = 'SELECT';
export const RANGE = 'RANGE';

export const SEARCH_TALENTS_REQUEST = 'SEARCH_TALENTS_REQUEST';
export const SEARCH_TALENTS_SUCCESS = 'SEARCH_TALENTS_SUCCESS';
export const SEARCH_TALENTS_FAILURE = 'SEARCH_TALENTS_FAILURE';

/**
 * Create action object that is used to search for talents.
 *
 * @param {string} token - JWT for request authentification.
 *
 * @return {Object}
 */
export const searchTalents = (token, query) => ({
  [API]: {
    endpoint: '/search/talents',
    method: 'GET',
    body: query,
    token,
    types: [
      SEARCH_TALENTS_REQUEST,
      SEARCH_TALENTS_SUCCESS,
      SEARCH_TALENTS_FAILURE,
    ],
  },
});

export const SEARCH_JOBS_REQUEST = 'SEARCH_JOBS_REQUEST';
export const SEARCH_JOBS_SUCCESS = 'SEARCH_JOBS_SUCCESS';
export const SEARCH_JOBS_FAILURE = 'SEARCH_JOBS_FAILURE';

/**
 * Create action object that is used to search for jobs.
 *
 * @param {string} token - JWT for request authentification.
 *
 * @return {Object}
 */
export const searchJobs = (token, query) => ({
  [API]: {
    endpoint: '/search/jobs',
    method: 'GET',
    body: query,
    token,
    types: [SEARCH_JOBS_REQUEST, SEARCH_JOBS_SUCCESS, SEARCH_JOBS_FAILURE],
  },
});
